import React from "react";
import { Col, Form, Input, Modal, theme, Row } from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";

export default function QualityChemicalMeterModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const { open, onClose, target, onUpdate } = props;
  const isCreate = target === 'add'
  const [errorMessages , setErrorMessages] = React.useState(null);
  
  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (!isCreate) {
        await PATCH(`${URL_CHEMICAL.METER}${target.id}/`, data);
      } else {
        await POST(URL_CHEMICAL.METER, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (target) {
      setErrorMessages(null)
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={!isCreate ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={!isCreate ? "แก้ไขมิเตอร์" : "เพิ่มมิเตอร์"}
      width={500}
      onOk={handleOK}
      okButtonProps={{
        style: { backgroundColor: !isCreate ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={14}>
            <Form.Item
              label="ชื่อมิเตอร์"
              name="name"
              rules={[{ required: true, message: "กรุณาระบุชื่อมิเตอร์" }]}
            >
              <Input autoComplete="off" placeholder="ชื่อมิเตอร์"/>
            </Form.Item>
          </Col>
          <Col span={10}>
          <Form.Item
              label="เลขมิเตอร์"
              name="current"
              rules={[{ required: true, message: "กรุณาระบุเลขมิเตอร์" }]}
            >
              <Input autoComplete="off" placeholder="เลขมิเตอร์"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
